export default {
  getAllSessions: (data = null) => $nuxt.$axios.get($nuxt.$api.hostV2 + '/fact-find/session', data),
  createSession: (data) => $nuxt.$axios.post($nuxt.$api.hostV2 + '/fact-find/session', data),
  getSession: (session_uuid) => $nuxt.$axios.get($nuxt.$api.hostV2 + '/fact-find/session/' + session_uuid),
  deleteSession: (session_uuid) => $nuxt.$axios.delete($nuxt.$api.hostV2 + '/fact-find/session/' + session_uuid),

  getAllTemplates: (data = null) => $nuxt.$axios.get($nuxt.$api.hostV2 + '/fact-find/templates', data),

  generatePDF: (template_uuid, data) =>
    $nuxt.$axios.post($nuxt.$api.hostV2 + '/fact-find/templates/' + template_uuid + '/generate-pdf', data),

  impersonateSession: (session_uuid, account_uuid) =>
    $nuxt.$axios.get($nuxt.$api.hostV2 + '/fact-find-session/' + session_uuid + '/account/' + account_uuid),
};
